<div class="metric-progress-bar" [attr.aria-label]="progressLabel">
  <ui-progress [uiPercent]="percent" [uiStrokeColor]="color" [uiSize]="'small'" [uiShowInfo]="false"></ui-progress>

  <div class="progress-label sp-ml-8">{{ progressToShow | number }}%</div>
</div>

<div
  class="delta sp-ml-8"
  *ngIf="deltaSignToShow || deltaValueToShow"
  [ngClass]="{ positive: delta >= 0.005, negative: delta <= -0.005 }"
  [attr.aria-label]="deltaLabel"
  [uiContent]="deltaPopoverContent"
  ui-popover
  uiTrigger="hover"
  uiPlacement="left">
  <div>{{ deltaSignToShow }}{{ deltaValueToShow | number }}%</div>
</div>

<ng-template #deltaPopoverContent>
  {{ "progress_in_last_14_days" | localize }}
</ng-template>
